import { PopoverInteractionKind, Position } from '@blueprintjs/core';
import { Classes, Popover2 } from '@blueprintjs/popover2';
import { faInfoCircle } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { NotificationSubscription } from '../../lib/actions/UserAction';
import { humanize } from '../../lib/Utility';

type NotificationSubscriptionsPopoverProps = {
  notificationSubscriptions: NotificationSubscription[];
};

const NotificationSubscriptionsTable = ({
  subscriptions,
}: {
  subscriptions: NotificationSubscription[];
}) => {
  const hasSubscriptions = subscriptions && subscriptions.length > 0;

  const groupedByMethod = hasSubscriptions
    ? subscriptions.reduce((acc, sub) => {
        const existingArray = acc[sub.method];
        if (existingArray) {
          existingArray.push(sub.state);
        } else {
          acc[sub.method] = [sub.state];
        }
        return acc;
      }, {} as Record<string, string[]>)
    : {};

  const formatMethod = (method: string) => {
    if (method === 'email') {
      return 'Email';
    } else {
      return 'SMS';
    }
  };

  return (
    <div className='notificationSubscriptionsPopover'>
      <h3 className='notificationSubscriptionsPopover__title'>
        Match notifications will send to this contact in the following states:{' '}
      </h3>

      {hasSubscriptions ? (
        Object.entries(groupedByMethod).map(([method, states]) => (
          <p key={method} className='notificationSubscriptionsPopover__method'>
            <strong>{formatMethod(method)}:</strong>{' '}
            {states.map(state => humanize(state)).join(', ')}
          </p>
        ))
      ) : (
        <p className='notificationSubscriptionsPopover__noConfig'>
          No notifications configured
        </p>
      )}
    </div>
  );
};

export default function NotificationSubscriptionsPopover({
  notificationSubscriptions,
}: NotificationSubscriptionsPopoverProps) {
  return (
    <Popover2
      interactionKind={PopoverInteractionKind.HOVER}
      popoverClassName={Classes.POPOVER2_CONTENT_SIZING}
      position={Position.TOP}
      fill={false}
      content={
        <NotificationSubscriptionsTable
          subscriptions={notificationSubscriptions}
        />
      }
    >
      <span className='notificationSubscriptionsPopover__icon'>
        <span className='u-push__left--xs'>
          <FontAwesomeIcon icon={faInfoCircle} />
        </span>
      </span>
    </Popover2>
  );
}
